import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import BreadcrumbDates from "../../../components/core/blocks/BreadcrumbDates";
import { AGENCY_DASHBOARD_BREADCRUMB_SPEC, DASHBOARD_LINKS } from "../../../utils/dashboardLinks";
import { useAdOptions } from "../api/useAdOptions";

const getDashboardTo = ({ type, id }) => {
  let to = `/user/category`;

  if (!id || type === "dashboard") {
    to = `/user/advertising/dashboard`;
  } else {
    if (type === "category") {
      to = `user/advertising/dashboard/category/${id}`;
    }
    if (type === "advertisement") {
      to = `/user/advertising/dashboard/ads/${id}`;
    }
  }

  return to;
};

const AdBreadcrumbs = ({ categoryId, categoryDetails, categoryData, currentAd }) => {
  const { t } = useTranslation(["advertising"]);

  const adOptionsQuery = useAdOptions({ categoryId, enabled: Boolean(categoryId) });

  const categoryAds = useMemo(
    () =>
      adOptionsQuery.options?.map((ad) => {
        const { id, name } = ad;
        return {
          ...ad,
          id,
          name,
          href: `/user/advertising/dashboard/ads/${id}`,
          isLoading: adOptionsQuery.isLoading,
        };
      }) ?? [],
    [adOptionsQuery.options, adOptionsQuery.isLoading],
  );

  const breadCrumbItems = useMemo(() => {
    return [
      AGENCY_DASHBOARD_BREADCRUMB_SPEC,
      {
        name: t(($) => $.advertising["Advertising Dashboard"]),
        href: getDashboardTo({
          type: "dashboard",
          id: null,
        }),
        dropdownLinkOptions: DASHBOARD_LINKS,
        searchable: false,
        unsorted: true,
        dropdownSubtitle: t(($) => $.advertising["Dashboards"]),
      },
      {
        name: categoryDetails?.leaf_category_name,
        href: categoryDetails?.href,
        dropdownLinkOptions: categoryData,
        searchable: true,
        searchPlaceholderText: t(($) => $.advertising["Search categories..."]),
        dropdownSubtitle: t(($) => $.advertising["Categories"]),
      },
      {
        name: currentAd?.name,
        href: currentAd?.href,
        dropdownLinkOptions: categoryAds,
        searchable: true,
        searchPlaceholderText: t(($) => $.advertising["Search media plans..."]),
        dropdownSubtitle: t(($) => $.advertising["Media Plans"]),
      },
    ];
  }, [t, categoryDetails, categoryData, categoryAds, currentAd]);

  return <BreadcrumbDates items={breadCrumbItems} />;
};

export default AdBreadcrumbs;
